const allowedPaths = [
  "/products/lions-mane-tincture",
  "/products/reishi-tincture",
  "/products/turkey-tail-tincture",
  "/products/lions-mane-bundle",
  "/products/menopause-support-bundle",
  "/products/glowing-skin-bundle",
  "/products/festive-recovery-bundle",
  "/products/organic-cordyceps-tincture",
  "/products/organic-chaga-tincture",
];

const isAllowedPath = allowedPaths.some(path =>
  window.location.pathname.includes(path)
);

const customerReferralItemSelector = `button.sca_aff_customer_refer_button`;

if (isAllowedPath) {
  function waitForCustomerReferralLoaded(a, b = 100) {
    const c = setInterval(function () {
      if (typeof uppromoteCustomerReferral !== "undefined") {
        a();
        clearInterval(c);
      }
    }, b);
    setTimeout(() => clearInterval(c), 5000);
  }

  function waitElementLoaded(a, b, c = 100) {
    const d = setInterval(function () {
      const el = document.querySelector(a);
      if (el) {
        b();
        clearInterval(d);
      }
    }, c);
    setTimeout(() => clearInterval(d), 5000);
  }

  waitElementLoaded(customerReferralItemSelector, function () {
    waitForCustomerReferralLoaded(function () {
      console.log("✅ Customer referral widget ready");
    });
  });
} else {
  const hideReferral = () => {
    const el = document.querySelector(customerReferralItemSelector);
    if (el) {
      el.style.display = "none";
    }
  };
  const waitToHide = setInterval(() => {
    const el = document.querySelector(customerReferralItemSelector);
    if (el) {
      hideReferral();
      clearInterval(waitToHide);
    }
  }, 100);
  setTimeout(() => clearInterval(waitToHide), 5000);
}
